﻿
import GroTranslator from './translator';
import { GroCommon } from './common';

export default window.validation = {
    phone: function (phoneNumber) {
        if (GroCommon.currentMarketSite() === GroCommon.MarketSite.Finland) {
            var phoneRegex = /^\+358[\s\d]{6,}/;

            return phoneRegex.test(phoneNumber);
        } else {
            phoneNumber = phoneNumber.replace(/\s+/g, "");
            var case1 = phoneNumber.substring(0, 1); // If user types in 0XXXXXXXX
            var case2 = phoneNumber.substring(0, 3); // If user types in 046XXXXXX
            var case3 = phoneNumber.substring(0, 4); // If user types in 0046XXXXX
            var case4 = phoneNumber.substring(0, 4); // If user types in +460XXXXX
            if (case1 === "0") {
                phoneNumber = phoneNumber.replace(/(\d{1})/, "+46");
                $("#Telephone").val(phoneNumber);
            }
            if (case2 === "046") {
                phoneNumber = phoneNumber.replace(/(\d{1})/, "+");
                $("#Telephone").val(phoneNumber);
            }
            if (case3 === "0046") {
                phoneNumber = phoneNumber.replace(/(\d{2})/, "+");
                $("#Telephone").val(phoneNumber);
            }
            if (case4 === "+460") {
                phoneNumber = phoneNumber.replace(/(\d{4})/, "+46");
                $("#Telephone").val(phoneNumber);
            }
            return phoneNumber.match(/^(\+46)\d{6,}$/);
        }
    },

    mobilephone: function (phoneNumber) {
        if (GroCommon.currentMarketSite() === GroCommon.MarketSite.Finland) {
            var phoneRegex = /^\+358[\s45][\s\d]{6,}/;

            return phoneRegex.test(phoneNumber);
        } else {
            phoneNumber = phoneNumber.replace(/\s+/g, "");
            var case1 = phoneNumber.substring(0, 2); // If user types in 07XXXXXXX
            var case2 = phoneNumber.substring(0, 3); // If user types in 046XXXXXX
            var case3 = phoneNumber.substring(0, 4); // If user types in 0046XXXXX
            var case4 = phoneNumber.substring(0, 5); // If user types in +4607XXXX
            if (case1 === "07") {
                phoneNumber = phoneNumber.replace(/(\d{1})/, "+46");
                $("#Mobilephone").val(phoneNumber);
            }
            if (case2 === "046") {
                phoneNumber = phoneNumber.replace(/(\d{1})/, "+");
                $("#Mobilephone").val(phoneNumber);
            }
            if (case3 === "0046") {
                phoneNumber = phoneNumber.replace(/(\d{2})/, "+");
                $("#Mobilephone").val(phoneNumber);
            }
            if (case4 === "+4607") {
                phoneNumber = phoneNumber.replace(/(\d{4})/, "467");
                $("#Mobilephone").val(phoneNumber);
            }
            return phoneNumber.match(/^(\+46)\d{9}$/);
        }
    },

    zipCode: function (zipCode) {
        var zipCodeRegex;
        if (GroCommon.currentMarketSite() === GroCommon.MarketSite.Finland) {
            zipCodeRegex = /^\d{5}$/;
        } else {
            zipCodeRegex = /^([1-9]\d{4}|[1-9]\d{2}\ \d{2})$/;
        }

        return zipCodeRegex.test(zipCode);
    },

    personNumber: function (personNumber) {
        personNumber = personNumber.replace(/\s+/g, "");
        return personNumber.match(/^\d{12}$/);
    },
    isoDate: function (isoDate) {
        var isoDateRegex = /^(\d{4})(\/|-)(\d{1,2})(\/|-)(\d{1,2})$/;
        return isoDate.match(isoDateRegex) && (new Date(isoDate) != "Invalid Date");
    },
    email: function(email) {
        var emailRegex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
        return email && email.length > 0 && emailRegex.test(email);
    }
};
// Alias for backward compatibility
window.validation.phoneSE = window.validation.phone;
window.validation.mobileSE = window.validation.mobilephone;
window.validation.swedishDate = window.validation.isoDate;

$(function () {
    window.validationMessage = {
        firstName: {
            required: GroTranslator.get("/common/validation/firstName/required")
        },
        lastName: {
            required: GroTranslator.get("/common/validation/lastName/required")
        },
        phoneSE: {
            valid: GroTranslator.get("/common/validation/phoneSE/valid")
        },
        mobileSE: {
            required: GroTranslator.get("/common/validation/mobileSE/required"),
            valid: GroTranslator.get("/common/validation/mobileSE/valid")
        },
        mobileFI: {
            required: GroTranslator.get("/common/validation/mobileFI/required"),
            valid: GroTranslator.get("/common/validation/mobileFI/valid")
        },
        zipCode: {
            required: GroTranslator.get("/common/validation/zipCode/required"),
            valid: GroTranslator.get("/common/validation/zipCode/valid")
        },
        email: {
            required: GroTranslator.get("/common/validation/email/required"),
            valid: GroTranslator.get("/common/validation/email/valid")
        },
        personNumber: {
            required: GroTranslator.get("/common/validation/personNumber/required"),
            valid: GroTranslator.get("/common/validation/personNumber/valid"),
            purchasingagreementssnvalid: GroTranslator.get("/common/validation/personNumber/purchasingagreementssnvalid")
        },
        swedishDate: {
            required: GroTranslator.get("/common/validation/swedishDate/required"),
            valid: GroTranslator.get("/common/validation/swedishDate/valid")
        }
    };
});

$(function () {
    if (!$.validator) {
        return;
    }

    $.validator.addMethod("phoneSE",
        function (phoneNumber, element) {
            return this.optional(element) || window.validation.phoneSE(phoneNumber);
        },
        window.validationMessage.phoneSE.valid);

    $.validator.addMethod("mobileSE",
        function (phoneNumber, element) {
            return window.validation.mobileSE(phoneNumber);
        },
        window.validationMessage.mobileSE.valid);

    $.validator.addMethod("zipCode",
        function (zipCode, element) {
            return this.optional(element) || window.validation.zipCode(zipCode);
        },
        window.validationMessage.zipCode.valid);

    $.validator.addMethod("personNumber",
        function (pn, element) {
            return this.optional(element) || window.validation.personNumber(pn);
        },
        window.validationMessage.personNumber.valid);
    $.validator.addMethod("email",
        function (email, element) {
            return this.optional(element) || window.validation.email(email);
        },
        window.validationMessage.email.valid);
    $.validator.addMethod("swedishDate",
        function (pn, element) {
            return window.validation.swedishDate(pn);
        },
        window.validationMessage.swedishDate.valid);
});
